/**
 * Urbanovac Predictive Search & Full-Screen Overlay Controller
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Overlay Elements
  const overlay = document.querySelector('[data-search-overlay]');
  const openTriggers = document.querySelectorAll('[data-search-overlay-open]');
  const closeTriggers = document.querySelectorAll('[data-search-overlay-close]');
  const overlayInput = document.querySelector('[data-search-overlay-input]');
  const clearBtn = document.querySelector('[data-search-overlay-clear]');
  const defaultState = document.querySelector('[data-search-default-state]');
  const resultsContainer = document.querySelector('[data-search-overlay-results]');
  const searchTags = document.querySelectorAll('[data-search-tag]');

  const cache = new Map();

  const openOverlay = () => {
    if (!overlay) return;
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-search-open');
    if (overlayInput) {
      setTimeout(() => {
        overlayInput.focus();
      }, 100);
    }
  };

  const closeOverlay = () => {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-search-open');
  };

  if (openTriggers.length > 0) {
    openTriggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openOverlay();
      });
    });
  }

  if (closeTriggers.length > 0) {
    closeTriggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeOverlay();
      });
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-active')) {
      closeOverlay();
    }
  });

  // Debounce helper
  const debounce = (fn, delay = 250) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const fetchOverlayResults = (query) => {
    if (!query || query.length < 2) {
      if (resultsContainer) {
        resultsContainer.style.display = 'none';
        resultsContainer.innerHTML = '';
      }
      if (defaultState) defaultState.style.display = 'block';
      if (clearBtn) clearBtn.style.display = 'none';
      return;
    }

    if (clearBtn) clearBtn.style.display = 'inline-flex';

    if (cache.has(query)) {
      renderOverlayResults(cache.get(query));
      return;
    }

    const predictiveUrl = window.TrendMart?.routes?.predictive_search_url || '/search/suggest';
    const url = `${predictiveUrl}?q=${encodeURIComponent(query)}&resources[type]=product,collection&section_id=predictive-search`;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('#predictive-search-results');
        const rendered = content ? content.innerHTML : '';
        cache.set(query, rendered);
        renderOverlayResults(rendered);
      })
      .catch(err => {
        console.error('Search error:', err);
      });
  };

  const renderOverlayResults = (html) => {
    if (!resultsContainer) return;
    if (defaultState) defaultState.style.display = 'none';
    resultsContainer.style.display = 'block';

    if (!html || html.trim().length === 0) {
      resultsContainer.innerHTML = `
        <div class="tm-search-no-results">
          <p>No products found matching your search. Try checking spelling or browsing popular styles below.</p>
        </div>
      `;
    } else {
      resultsContainer.innerHTML = html;
    }
  };

  if (overlayInput) {
    overlayInput.addEventListener('input', debounce((e) => {
      fetchOverlayResults(e.target.value.trim());
    }, 250));

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        overlayInput.value = '';
        fetchOverlayResults('');
        overlayInput.focus();
      });
    }
  }

  if (searchTags.length > 0) {
    searchTags.forEach(tag => {
      tag.addEventListener('click', () => {
        const val = tag.getAttribute('data-search-tag') || tag.textContent.trim();
        if (overlayInput) {
          overlayInput.value = val;
          fetchOverlayResults(val);
          overlayInput.focus();
        }
      });
    });
  }

  // 2. Inline Search Legacy Support (if present)
  const legacyInput = document.querySelector('[data-search-input]:not([data-search-overlay-input])');
  const legacyResults = document.querySelector('[data-predictive-search-container]');
  if (legacyInput && legacyResults) {
    legacyInput.addEventListener('input', debounce((e) => {
      const q = e.target.value.trim();
      if (q.length < 2) {
        legacyResults.classList.remove('is-active');
        return;
      }
      const predictiveUrl = window.TrendMart?.routes?.predictive_search_url || '/search/suggest';
      fetch(`${predictiveUrl}?q=${encodeURIComponent(q)}&resources[type]=product,collection&section_id=predictive-search`)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('#predictive-search-results');
          legacyResults.innerHTML = content ? content.innerHTML : '';
          legacyResults.classList.add('is-active');
        });
    }, 250));
  }
});
